var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voir-tous-les-uses-cases"},[_c('p',{staticClass:"voir-tous-les-uses-cases-1 montserrat-medium-gunsmoke-18px"},[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":"/nos-use-cases"}},[_c('span',{staticClass:"span-2 montserrat-medium-gunsmoke-18px"},[_vm._v("Voir tous les use cases >")])])])])
}]

export { render, staticRenderFns }